import { useEffect, useMemo } from 'react';
import LandingPage, { LandingPageInitialData } from '../../components/HomePage';

declare global {
  interface Window {
    __SSR_DATA__?: LandingPageInitialData;
  }
}

function getSSRData(): LandingPageInitialData | undefined {
  if (typeof window !== 'undefined' && window.__SSR_DATA__) {
    return window.__SSR_DATA__;
  }
  return undefined;
}

export default function HomePageSSR() {
  const initialData = useMemo(() => getSSRData(), []);

  useEffect(() => {
    const ssrContent = document.getElementById('ssr-content');
    if (ssrContent) {
      ssrContent.remove();
    }
  }, []);

  return (
    <main>
      <LandingPage initialData={initialData} />
    </main>
  );
}
